import React from 'react'
import { bool, func } from 'prop-types'
import CarouselBase from '@hugeinc/carousel/dist/carousel.cjs'
import { debounce, flatten } from 'lodash'
import '@hugeinc/carousel/src/carousel.css'

import { isMobile, isDesktop } from '../../../utils/mediaQuery'
import Icon from '../../elements/Icon/Icon'

import { CarouselWrapper, IconColor, Item, List, Navigator, NavigatorList, NavItem } from './styles'

class Carousel extends React.Component {
  state = {
    startedCarousel: false
  }

  componentDidMount() {
    if (typeof window === 'undefined') {
      return
    }

    if (this.props.mobileOnly) {
      window.addEventListener('resize', this.resizeHandler)
      this.handleMobileCarousel()
    } else if (!this.carousel) {
      this.mountCarousel()
    }
  }

  componentWillUnmount() {
    if (this.props.mobileOnly) {
      window.removeEventListener('resize', this.resizeHandler)
    }
    if (this.carousel) {
      this.carousel.destroy()
    }
  }

  onSlide = to => {
    this.setState({
      activeSlide: to
    })

    if (this.props.onSlide) {
      this.props.onSlide()
    }
  }

  mountCarousel = () => {
    const options = {
      onSlide: this.onSlide,
      activeClass: 'active',
      slideWrap: 'ul',
      slides: 'li',
      infinite: false,
      display: 1,
      disableDragging: false,
      initialIndex: 0
    }

    if (this._carousel) {
      this.carousel = new CarouselBase(this._carousel, options)
      this.setState({
        startedCarousel: true,
        activeSlide: this.carousel.current
      })
    }
  }

  handleMobileCarousel = debounce(
    () => {
      if (isMobile() && !this.carousel) {
        this.mountCarousel()
      }

      if (isDesktop() && this.carousel) {
        this._wrap.style.transform = 'none'
        this.carousel.destroy()
        this.setState({ startedCarousel: false })
        delete this.carousel
      }
    },
    250,
    {
      maxWait: 1000
    }
  )

  resizeHandler = () => {
    this.handleMobileCarousel()
  }

  moveCarousel = to => {
    this.carousel.go(to)
  }

  mountNavigator = (listItems, hasArrow) => (
    <Navigator hasArrow={hasArrow}>
      {hasArrow &&
        !isMobile() && (
          <Icon
            icon="left-arrow-large"
            svgStyle={IconColor}
            width="30"
            height="30"
            viewBox="0 0 70 70"
            onClick={() => this.moveCarousel(this.carousel.current - 1)}
          />
        )}
      <NavigatorList>
        {listItems.map((child, index) => (
          <NavItem
            active={this.state.activeSlide === index}
            key={index}
            onClick={() => this.moveCarousel(index)}
          />
        ))}
      </NavigatorList>
      {hasArrow &&
        !isMobile() && (
          <Icon
            icon="right-arrow-large"
            svgStyle={IconColor}
            width="30"
            height="30"
            viewBox="15 15 70 70"
            onClick={() => this.moveCarousel(this.carousel.current + 1)}
          />
        )}
    </Navigator>
  )

  handleMountNavigator = listItems => {
    if ((isMobile() && this.props.hasMobileNavigation) || this.props.hasNavigation)
      return this.mountNavigator(listItems, this.props.hasArrow)
  }

  render() {
    const { children, flexibleWidth, fullWidth } = this.props

    const listItems = flatten(children).filter(child => child)

    return (
      <CarouselWrapper
        mobileOnly={this.props.mobileOnly}
        className="carousel"
        startedCarousel={this.state.startedCarousel}
        fullWidth={fullWidth}
        innerRef={el => {
          this._carousel = el
        }}
      >
        <List
          className="wrap"
          innerRef={el => {
            this._wrap = el
          }}
        >
          {listItems.map((child, index) => (
            <Item flexibleWidth={flexibleWidth} key={index}>
              {child}
            </Item>
          ))}
        </List>
        {this.handleMountNavigator(listItems)}
      </CarouselWrapper>
    )
  }
}

Carousel.defaultProps = {
  onSlide: null,
  mobileOnly: true,
  fullWidth: true
}

Carousel.propTypes = {
  onSlide: func,
  mobileOnly: bool
}

export default Carousel



// WEBPACK FOOTER //
// ./src/app/elements/Carousel/index.js